import { IterableIteratorSlots, Types } from '../../constants';
import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinSlotInstanceMemberCall } from '../BuiltinSlotInstanceMemberCall';
class IterableIteratorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('IterableIterator', new IterableIteratorInterface());
    builtins.addGlobalMember('Iterator', 'next', new BuiltinSlotInstanceMemberCall(Types.IterableIterator, IterableIteratorSlots.next));
    builtins.addGlobalMember('IterableIterator', '__@iterator', new BuiltinSlotInstanceMemberCall(Types.IterableIterator, IterableIteratorSlots.iterator));
};

//# sourceMappingURL=index.js.map
